export const THEATER_BANNER_CONFIG_KEY = 'banner';
export const THEATER_BANNER_CONFIG_MODULE = 'common';
export const THEATER_BANNER_PERMISSION = 'Dramas_Banner';
export const THEATER_BANNER_UPDATE_PERMISSION = 'Dramas_Banner_Update';
/** 客户端 Banner 最多条目数 */
export const THEATER_BANNER_MAX_ITEMS = 10;
